import { createApp } from 'vue'
import App from './App.vue'
import VueMaplibreGl from 'vue-maplibre-gl'
import './registerServiceWorker'

const app = createApp(App)
app.use(VueMaplibreGl)
app.mount('#app')
